import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { round6 as round } from 'utilities/math';
import {
  isRequiredNumber,
  isRequiredNumberGreaterThan,
  isRequiredIntegerGreaterThan
} from 'utilities/validators.js';

import Input from 'components/Input';
import Dropdown from '../Dropdown';

const isPositiveNumber = isRequiredNumberGreaterThan(0);
const isMoreThanOneInteger = isRequiredIntegerGreaterThan(1);

class SettingsFormComponent extends React.PureComponent {
  formatFn = value => (value || value === 0 ? round(value) : '');

  listOfNumericalVariables = this.props.getNumericalOptionsDataSet();

  render () {
    const {
      firstVariable,
      secondVariable,
      getNumericalOptionsDataSet,
      onGenerateMeanDataSetFirst,
      onGenerateMeanDataSetSecond,
      handleFirstGroupInputs,
      handleSecondGroupInputs
    } = this.props;
    return (
      <>
        {
          this.listOfNumericalVariables.length > 0
            ? (
              <Dropdown
                isClearable
                optionsList={getNumericalOptionsDataSet(secondVariable)}
                label="Sample Variable #1"
                name="firstVariable"
                placeholder="Select a Variable"
                onChange={onGenerateMeanDataSetFirst}
                id="firstVariable"
                labelClassName="font-900 font-14 mb-5"
              />
            )
            : (
              <span className="font-14 font-900 mb-10">Sample Variable #1</span>
            )
        }
        <div className="flex space-between mb-15">
          <Field
            type="number"
            id="sampleMeanFirst"
            component={Input}
            name="sampleMeanFirst"
            label="Sample Mean"
            pattern="\d+"
            format={this.formatFn}
            validate={isRequiredNumber}
            onChange={handleFirstGroupInputs}
            wrapperClassName="relative width-32 iconTop two-lines"
            inputClassName="main-input__input"
            labelClassName="main-input__label width-70"
          />
          <Field
            type="number"
            id="standardDeviationFirst"
            component={Input}
            name="standardDeviationFirst"
            label="Sample St. Dev."
            pattern="\d+"
            min={1}
            format={this.formatFn}
            validate={isPositiveNumber}
            onChange={handleFirstGroupInputs}
            wrapperClassName="relative width-32 iconTop two-lines"
            inputClassName="main-input__input"
            labelClassName="main-input__label width-70"
          />
          <Field
            type="number"
            id="sampleSizeFirst"
            component={Input}
            name="sampleSizeFirst"
            label="Sample Size"
            pattern="\d+"
            min={2}
            format={this.formatFn}
            validate={isMoreThanOneInteger}
            onChange={handleFirstGroupInputs}
            wrapperClassName="relative width-32 iconTop two-lines"
            inputClassName="main-input__input"
            labelClassName="main-input__label width-70"
          />
        </div>
        {
          this.listOfNumericalVariables.length > 1
            ? (
              <Dropdown
                isClearable
                optionsList={getNumericalOptionsDataSet(firstVariable)}
                label="Sample Variable #2"
                name="secondVariable"
                placeholder="Select a Variable"
                onChange={onGenerateMeanDataSetSecond}
                id="secondVariable"
                labelClassName="font-900 font-14 mb-5"
              />
            )
            : (
              <span className="font-14 font-900 mb-10">Sample Variable #2</span>
            )
        }
        <div className="flex space-between mb-25">
          <Field
            type="number"
            id="sampleMeanSecond"
            component={Input}
            name="sampleMeanSecond"
            label="Sample Mean"
            pattern="\d+"
            format={this.formatFn}
            validate={isRequiredNumber}
            onChange={handleSecondGroupInputs}
            wrapperClassName="relative width-32 iconTop two-lines"
            inputClassName="main-input__input"
            labelClassName="main-input__label width-70"
          />

          <Field
            type="number"
            id="standardDeviationSecond"
            component={Input}
            name="standardDeviationSecond"
            label="Sample St. Dev."
            pattern="\d+"
            min={1}
            format={this.formatFn}
            validate={isPositiveNumber}
            onChange={handleSecondGroupInputs}
            wrapperClassName="relative width-32 iconTop two-lines"
            inputClassName="main-input__input"
            labelClassName="main-input__label width-70"
          />

          <Field
            type="number"
            id="sampleSizeSecond"
            component={Input}
            name="sampleSizeSecond"
            label="Sample Size"
            pattern="\d+"
            min={2}
            format={this.formatFn}
            validate={isMoreThanOneInteger}
            onChange={handleSecondGroupInputs}
            wrapperClassName="relative width-32 iconTop two-lines"
            inputClassName="main-input__input"
            labelClassName="main-input__label width-70"
          />
        </div>
      </>
    );
  }
}


SettingsFormComponent.propTypes = {
  firstVariable: PropTypes.string,
  secondVariable: PropTypes.string,
  getNumericalOptionsDataSet: PropTypes.func.isRequired,
  onGenerateMeanDataSetFirst: PropTypes.func.isRequired,
  onGenerateMeanDataSetSecond: PropTypes.func.isRequired,
  handleFirstGroupInputs: PropTypes.func.isRequired,
  handleSecondGroupInputs: PropTypes.func.isRequired
};

export default SettingsFormComponent;
